import { ContextMenu, type ContextMenuItem } from '@indipia/ui-core'
import { useCommonCodes } from '../../context/CommonCodesContext'
// 간트 바 우클릭 컨텍스트 메뉴 — '이 공종 뒤에 추가 ›' 에서 공종을 고르면 공종 추가 팝업이 그 공종으로 열린다(B-18).
// 시작일 기본값(선택 공종 종료일 + 1)과 선행 삽입 위치(선택 공종 뒤)는 현행 그대로다.

export type GanttContextMenuProps = {
  ctxMenu: { x: number; y: number; taskId: number; taskName: string; taskEndDate: Date; } | null
  /** 바깥 클릭·Esc 닫기는 메뉴 컴포넌트가 처리한다 — 호출 화면 호환용으로만 받음 */
  ctxMenuRef?: React.RefObject<HTMLDivElement>
  setAddPopDefaults: React.Dispatch<React.SetStateAction<{ workTypeCode?: string; predecessorId: number; defaultStartDate?: string; } | null>>
  setCtxMenu: React.Dispatch<React.SetStateAction<{ x: number; y: number; taskId: number; taskName: string; taskEndDate: Date; } | null>>
  setShowAddPop: React.Dispatch<React.SetStateAction<boolean>>
}

export function GanttContextMenu({ ctxMenu, setAddPopDefaults, setCtxMenu, setShowAddPop }: GanttContextMenuProps) {
  const { codes } = useCommonCodes()
  if (!ctxMenu) return null

  const openAddPopup = (workTypeCode?: string) => {
    const nextDay = new Date(ctxMenu.taskEndDate); nextDay.setDate(nextDay.getDate() + 1)
    const nextDayISO = `${nextDay.getFullYear()}-${String(nextDay.getMonth()+1).padStart(2,'0')}-${String(nextDay.getDate()).padStart(2,'0')}`
    setAddPopDefaults({ predecessorId: ctxMenu.taskId, defaultStartDate: nextDayISO, ...(workTypeCode && { workTypeCode }) })
    setCtxMenu(null)
    setShowAddPop(true)
  }

  // 공종 목록은 공종 마스터(공통코드) — 아직 못 받았으면 하위 메뉴 없이 공종 추가 팝업만 연다(현행 동작)
  const workTypes = codes?.workTypes ?? []
  const items: ContextMenuItem[] = [
    workTypes.length > 0
      ? {
        key: 'add-after',
        label: '이 공종 뒤에 추가',
        items: workTypes.map(w => ({ key: w.workTypeCode, label: w.workTypeName, onSelect: () => openAddPopup(w.workTypeCode) })),
      }
      : { key: 'add-after', label: '이 공종 뒤에 추가', onSelect: () => openAddPopup() },
  ]

  return (
    <ContextMenu
      open
      x={ctxMenu.x}
      y={ctxMenu.y}
      onClose={() => setCtxMenu(null)}
      aria-label={`${ctxMenu.taskName} 메뉴`}
      heading={ctxMenu.taskName}
      items={items}
    />
  )
}
